import { Box, TextField, Tooltip } from "@mui/material";
import { getInputLabelProps, getInputProps } from "../../common/appStyles";
import localize from "../../common/localize";
import { useState } from "react";
import { Search } from "@mui/icons-material";
import CryptoJS from "crypto-js";
import { encryptForUrl } from "../../common/utils";

export default function EventSearcherHeader() {
  const [searchValue, setSearchValue] = useState("");
  const [hasError, setHasError] = useState(false);

  const handleChange = (e) => {
    setSearchValue(e.target.value);
  };

  const getEventsFilter = () => {
    const valueWithoutSpaces = searchValue.replaceAll(" ", "").trim();
    return encryptForUrl(
      JSON.stringify([
        {
          Name: "Code",
          FriendlyName: localize.code,
          FilterValue: { Value: valueWithoutSpaces },
          Value: valueWithoutSpaces,
        },
      ])
    );
  };

  const searchEvent = () => {
    setHasError(undefined);
    if (!searchValue || searchValue.replaceAll(" ", "").length === 0) {
      setHasError(true);
      return;
    }
    window.open(`/events?filter=${getEventsFilter()}`, "_blank");
  };

  const handleKeyUp = (event) => {
    if (event.key === "Enter") {
      searchEvent();
    }
  };

  return (
    <Tooltip title={localize.search_event_by_code}>
      <Box
        className="flex w-full"
        sx={{
          gap: "0px",
          userSelect: "none",
          "&:focus": {
            backgroundColor: "transparent",
            outline: "none",
          },
          "&:active": {
            backgroundColor: "transparent",
          },
        }}
      >
        <TextField
          error={hasError}
          sx={{
            width: "100%",
            input: { color: "white" },
            label: { color: "white" },
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "white",
              },
              "&:hover fieldset": {
                borderColor: "white",
              },
              "&.Mui-focused fieldset": {
                borderColor: "white",
              },
            },
          }}
          InputLabelProps={getInputLabelProps()}
          inputProps={getInputProps()}
          size="small"
          fullWidth
          id="outlined-basic"
          name="Name"
          label={localize.code}
          variant="outlined"
          onChange={handleChange}
          value={searchValue}
          onKeyUp={handleKeyUp}
        />
        <button
          style={{
            backgroundColor: "white",
            padding: "6.5px 6px 6px 6px",
            position: "relative",
            left: "-3px",
            borderRadius: "0px 2px 2px 0px",
          }}
          onClick={searchEvent}
        >
          <Search sx={{ width: "24px", height: "24px", color: "#10366e" }} />
        </button>
      </Box>
    </Tooltip>
  );
}
